// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — alert-button.classic.js, новая — alert-button.cp.js
import { isCp } from 'libs/design';
import * as classic from './alert-button.classic';
import * as cp from './alert-button.cp';

export const AlertButton = isCp ? cp.AlertButton : classic.AlertButton;
